import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/werewolf/page.tsx");
